const matrixFunctions = {
  create: (rows, cols) => new Array(rows).fill(null).map(() => new Array(cols).fill(null)),
  getRowsCount: matrix => matrix.length,
  getColumnsCount: matrix => matrix[0].length,
  getColumns: matrix => new Array(matrixFunctions.getColumnsCount(matrix)).fill(null).map((_, ind) => matrix.map(f => f[ind])),
  addRow: (matrix, fnc) => [...matrix, new Array(matrixFunctions.getColumnsCount(matrix)).fill(null).map(() => (fnc ? fnc() : null))],
  addRowAt: (matrix, rowInd, fnc) => {
    const ret = matrixFunctions.addRow(matrix, fnc);
    return matrixFunctions.moveRow(ret, matrixFunctions.getRowsCount(ret) - 1, rowInd);
  },
  addColumn: (matrix, fnc) => matrix.map(f => [...f, fnc ? fnc() : null]),
  addColumnAt: (matrix, colInd, fnc) => {
    const ret = matrixFunctions.addColumn(matrix, fnc);
    return matrixFunctions.moveColumn(ret, matrixFunctions.getColumnsCount(ret) - 1, colInd);
  },
  removeRow: (matrix, rowInd) => matrix.filter((_, ind) => ind !== rowInd),
  removeColumn: (matrix, colInd) => matrix.map(f => f.filter((_, ind) => ind !== colInd)),
  moveRow: (matrix, from, to) => {
    const ret = matrix.filter((_, ind) => ind !== from);
    ret.splice(to, 0, matrix[from]);
    return ret;
  },
  moveRows: (matrix, froms, to) => {
    const newTo = to - froms.filter(f => f < to).length;
    const ret = matrix.filter((_, ind) => !froms.includes(ind));
    froms.forEach((from, ind) => ret.splice(newTo + ind, 0, matrix[from]));
    return ret;
  },
  moveColumn: (matrix, from, to) => {
    const ret = matrix.map((f) => {
      const row = f.filter((_, ind) => ind !== from);
      row.splice(to, 0, f[from]);
      return row;
    });
    return ret;
  },
  moveColumns: (matrix, froms, to) => {
    const newTo = to - froms.filter(f => f < to).length;
    const ret = matrix.map((f) => {
      const row = f.filter((_, ind) => !froms.includes(ind));
      froms.forEach((from, ind) => row.splice(newTo + ind, 0, f[from]));
      return row;
    });
    return ret;
  },
  getCell: (matrix, rowInd, colInd) => matrix[rowInd][colInd],
  setCell: (matrix, rowInd, colInd, cell) => {
    const ret = matrix.map(f => f.map(g => g));
    ret[rowInd][colInd] = cell;
    return ret;
  },
  getAllCells: matrix => matrix.flatMap((f, rowInd) => f.map((g, colInd) => ({ rowInd, colInd, cell: g }))),
};

export default matrixFunctions;

